var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99369 0.209705C7.57098 -0.0953203 6.95978 -0.0675907 6.57135 0.292893L6.48172 0.387101C6.15305 0.779392 6.18293 1.34662 6.57135 1.70711L11.1963 6H0.232422V8H11.1963L6.57135 12.2929L6.48172 12.3871C6.15305 12.7794 6.18293 13.3466 6.57135 13.7071C6.99215 14.0976 7.6744 14.0976 8.0952 13.7071L15.3222 7L8.0952 0.292893L7.99369 0.209705Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.9ed0f211.svg";
export { ForwardRef as ReactComponent };